import { invoke } from '../event/general-event-list/index.js'
import { trackEvent } from '../trackEvent/index.js'

export default {
  methods: {
    $trackEvent (key, payload = {}, eventName) {
      try {
        const { state: { dataCenter } } = this.$store
        if (eventName) {
          const refId = this.$el?.id || ''
          const evtData = refId && eventName ? dataCenter.eventTable[refId][eventName] : {}
          const eventData = evtData || {}
          const { omegaTrack, action, actionName } = eventData
          payload = { ...payload, omegatrack: omegaTrack, action, actionName }
        }
        payload.scene = this.scene || 1
        payload.rank = /dialog|Dialog|popup|Popup/.test(this.$options.name) ? dataCenter.level + 1 : dataCenter.level
        trackEvent(key, payload)
      } catch (error) {
        console.error('该事件未注册')
      }
    },
    $xpubEvent (eventName) {
      try {
        const { state: { dataCenter } } = this.$store
        if (!eventName) {
          return console.error('请传递要触发的事件名')
        }
        const refId = this.$el?.id || ''
        if (!refId) {
          return console.error('无法获取当前组件ID')
        }
        const evtData = dataCenter.eventTable[refId][eventName]
        const eventData = evtData || {}
        invoke(eventData)
      } catch (error) {
        console.error('该事件未注册')
      }
    }
  }
}
